import { requestListBy } from "api/Request";
import { REQUEST_ID } from "constants/Constants";
import { KAMCO_CONFIG } from "constants/Kamco";
import { useMapImages } from "hooks/ol/useMapImages";
import { useOpenLayers } from "hooks/ol/useOpenLayers";
import { useWMTS } from "hooks/ol/useWMTS";
import { DetailPanelStateStore } from "stores/DetailState";
import { FilterStateStore } from "stores/FilterState";
import { RequestStore } from "stores/RequestList";
import { SelectedRequestStore } from "stores/SelectedRequest";
import { SystemStore } from "stores/System";
import { TRequestContent } from "types/TRequest";


export const useRequest = () => {
    const { request, setSelected, clear } = SelectedRequestStore();
    const { requestList, getRequestCollection, setRequest, addRequestCollection, toCollection } = RequestStore();
    const { actions, page } = FilterStateStore();
    const { drawBBox, clearAll, initSwipe, initMap } = useOpenLayers();
    const mapImages = useMapImages();
    const { isDetail, setIsDetail } = DetailPanelStateStore();
    const { isKamcoDemo, setIsKamcoDemo } = SystemStore();
    const { addWMTS, removeAllWMTS } = useWMTS();

    const loadRequestListByProject = async (id: number) => {
        if (!id) return;
        const data = await requestListBy(id, actions.getFilter());
        setRequest(data);
    };

    const setRequestByQuaryParam = (collection: Map<string, number>) => {
        const rId = collection.get(REQUEST_ID);
        try {
            const find = getRequestCollection().get(rId ?? 0);
            if (!find) throw `invalid Request ID. requestId : ${rId}`;
            setSelected(find);
            setIsDetail(true);
            drawBBox(find);
        } catch (e) {
            console.info(e);
        }
    }

    const getNextRequest = async (id: number) => {
        const currentPage = page;
        actions.addPage(currentPage + 1);
        const list = await requestListBy(id, actions.getFilter());
        list && list.content && addRequestCollection(toCollection(list.content));
        list && list.content.length === 0 && actions.addPage(currentPage);
        return list ? list.content.length > 0 : false;
    };

    const onSelectRequest = (task: TRequestContent) => {
        setIsDetail(false);
        const isKamco = task.id === KAMCO_CONFIG.KAMCO_DEMO_REQUEST_ID;
        setIsKamcoDemo(isKamco);
        drawBBox(task, request?.id !== task.id);
        if (isKamco) {
            addWMTS(KAMCO_CONFIG.BASE_WMTS_URL, KAMCO_CONFIG.BASE_WMTS_LAYER, "base");
        } else {
            removeAllWMTS();
            mapImages.drawBaseImage(task.requestImageDataList[0].imageTileUrl);
        }
        setSelected(task);
    }

    const onClickDetail = (is: boolean = true) => {
        setIsDetail(is);
    }

    const initRequestMap = () => {
        isKamcoDemo && removeAllWMTS();
        clearAll();
        initSwipe();
        initMap();
    }

    return {
        selectedRequest: request,
        requestList,
        isDetail,
        request,
        setSelected,
        setRequestByQuaryParam,
        loadRequestListByProject,
        getNextRequest,
        onSelectRequest,
        onClickDetail,
        initRequestMap,
        clearSelectedRequest: clear
    }

}
